import { isLoadEvent, type Events } from '../core/TimeData';
import type { PortCostPair } from './context';

export const getMarcuraPortCostPairs = (
  eventGroups: Events[][],
): PortCostPair[] => {
  const pairMap = Object.create(null);

  const ordersInEventGroups = eventGroups.flatMap((eg) =>
    eg.filter(isLoadEvent).map((e) => e.order),
  );

  for (const {
    locationByLoadPortId,
    locationByDischargePortId,
    assortmentByAssortmentId,
  } of ordersInEventGroups) {
    const loadPortId = locationByLoadPortId?.id;
    const dischargePortId = locationByDischargePortId?.id;
    const assortmentId = assortmentByAssortmentId?.id;
    if (assortmentId) {
      if (loadPortId) {
        const pair: PortCostPair = [loadPortId, assortmentId];
        pairMap[pair.join('_')] = pair;
      }
      if (dischargePortId) {
        const pair: PortCostPair = [dischargePortId, assortmentId];
        pairMap[pair.join('_')] = pair;
      }
    }
  }

  return Object.values(pairMap);
};
